<template>
  <van-cell-group v-if="data.length">
    <van-cell @click="jump(item)" v-for="(item, index) in data" :key="index" >
      <template #title>
        <div>{{ item.articleTitle }}</div>
        <div style="color:rgba(0,0,0,0.3)">{{ item.createTime }}</div>
      </template>

    </van-cell>
  </van-cell-group>
  <van-empty v-else description="暂无数据" />
</template>

<script>
import Vue from "vue";
import { Cell, CellGroup, Empty } from "vant";
import { post } from "@/utils/request";
import { goToApp } from '@/utils/userInfo';
import { meBaseUrl } from '@/constant' 
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Empty);
export default {
  props: {},
  data() {
    return {
      data: []
    };
  },
  components: {

  },
  created() {
    if (this.$route.query.title) {
      document.title = this.$route.query.title
    }
    post({
      url: '/article/open/articleInfo/findArticleList',
      data: {
        articleTypeId: this.$route.query.articleTypeId,
        size: 9999
      }
    }).then(res => {
      if (res.code === 0) {
        this.data = res.data.records
      }
    })
  },
  methods: {
    jump(item) {
      if (!this.$store.state.appInfo.isApp) {
        this.$router.push(`/web/article/detail?id=${item.idStr}&_immersive=0`)
      } else {
        goToApp(`${meBaseUrl}/web/article/detail?id=${item.idStr}&_immersive=0`)
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.license {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  // background-color: #ffffff;
  .img_wrap {
    padding: 10px;
  }

  .img_title {
    text-align: center;
    padding: 10px 0;
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
}
</style>
